<template>
  <div>
    <Header page="my_page"/>
    <b-container class="mt-5">
      <b-row>
        <b-col cols="12" lg="3" class="mypage__sidebar">
          <SidebarMypage myPage="history"/>
        </b-col>
        <b-col cols="12" lg="9" class="pl-70">
          <HistoryView />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SidebarMypage from '@/views/Employee/MyPage/SidebarMypage'
import Header from '@/components/share/Header'
import HistoryView from '@/components/Employee/mypage/HistoryView'
export default {
  name: 'HistoryMypage',
  components: {
    Header,
    SidebarMypage,
    HistoryView
  },
  data () {
    return {
      items: [
        {
          text: 'ホーム',
          href: '#'
        },
        {
          text: 'マイページ',
          href: '#'
        },
        {
          text: '観覧履歴',
          active: true
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/MyPage/HistoryMypage.vue